import { FirebaseDataService } from "src/services/Firebase/data";

export const cloudClockIn = async (data) => {
  return FirebaseDataService.employeeClockIn(data);
};

export const cloudClockOut = async (data) => {
  return FirebaseDataService.employeeClockOut(data);
};
